import { render } from "./MoveToTopSpot.vue?vue&type=template&id=ca8d534e"
import script from "./MoveToTopSpot.vue?vue&type=script&lang=js"
export * from "./MoveToTopSpot.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__